import { LeafletPanelBody, LeafletPanelHeading } from "../shared/LeafletPanel";

import { observer } from "mobx-react-lite";
import { Div, Section } from "trunx";
import { useLocaleContext } from "../contexts/LocaleContext";
import { useRootStore } from "../models/Root";
import { SensorDisplayPrecip, SensorDisplayStream } from "../models/SensorDisplay";
import PrecipLegend from "./SensorsPanel/PrecipLegend";
import SelectSensorFilter from "./SensorsPanel/SelectSensorFilter";
import StreamLegend from "./SensorsPanel/StreamLegend";

interface SensorsPanelProps {
  mobileView?: "select" | "legend";
  onMobileSelect?: () => void;
}

const SensorsPanel = ({
  mobileView = "select",
  onMobileSelect,
}: SensorsPanelProps) => {
  const {
    dict: {
      panel: { sensors: dict },
    },
  } = useLocaleContext();

  const {
    sensors: { display },
    menus: { closePanel },
    isMobile,
  } = useRootStore();

  const Legend = ({ collapsible }: { collapsible?: boolean }) => (
    <>
      {SensorDisplayPrecip.is(display) && (
        <PrecipLegend display={display} collapsible={collapsible} />
      )}
      {SensorDisplayStream.is(display) && (
        <StreamLegend display={display} collapsible={collapsible} />
      )}
    </>
  );

  if (isMobile) {
    return (
      <Div
        bulma="panel"
        className={`mobile-sensors-panel${
          mobileView === "legend" ? " mobile-card" : ""
        }`}
        data-cy="mobile-sensors-panel"
      >
        <LeafletPanelBody>
          <Section>
            {mobileView === "legend" ? (
              <Legend collapsible />
            ) : (
              <SelectSensorFilter onSelect={onMobileSelect} />
            )}
          </Section>
        </LeafletPanelBody>
      </Div>
    );
  }

  return (
    <Div bulma="panel">
      <Div bulma="panel-heading">
        <LeafletPanelHeading title={dict.title} close={closePanel} />
      </Div>
      <LeafletPanelBody minHeight="500px">
        <Section>
          <SelectSensorFilter />
          <Legend />
        </Section>
      </LeafletPanelBody>
    </Div>
  );
};

export default observer(SensorsPanel);
